import { User as FirebaseUser } from 'firebase/auth';
import { UserDisplaySettings } from '@mono-repo-starter/types';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface AuthStoreState {
  currentUser: FirebaseUser | null;
  userSettings: UserDisplaySettings | null;
  isInitializing: boolean;
  isLoadingUserSettings: boolean;
  isAuthActionInProgress: boolean;
}

export interface AuthStoreActions {
  setCurrentUser: (user: FirebaseUser | null) => void;
  setUserSettings: (settings: UserDisplaySettings | null) => void;
  setInitializing: (initializing: boolean) => void;
  setLoadingUserSettings: (loading: boolean) => void;
  setIsAuthActionInProgress: (inProgress: boolean) => void;
}

export type AuthStore = AuthStoreState & AuthStoreActions;

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      currentUser: null,
      userSettings: null,
      isInitializing: true,
      isLoadingUserSettings: true,
      isAuthActionInProgress: false,
      setCurrentUser: (user) => set({ currentUser: user }),
      setUserSettings: (settings) => set({ userSettings: settings }),
      setInitializing: (initializing) => set({ isInitializing: initializing }),
      setLoadingUserSettings: (loading) => set({ isLoadingUserSettings: loading }),
      setIsAuthActionInProgress: (inProgress) => set({ isAuthActionInProgress: inProgress }),
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ userSettings: state.userSettings }),
    }
  )
);

